/* Progressive enhancement: native links, details and all copy work without JS. */
(() => {
  'use strict';
  if (window.__etStoryReady) return;
  window.__etStoryReady = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mounted = new WeakMap();
  function init(scope) {
    scope.querySelectorAll('[data-et-story], [data-et-faq]').forEach(root => {
      if (mounted.has(root)) return;
      const cleanups = [];
      if (document.body.dataset.motion !== 'false' && !motion.matches && 'IntersectionObserver' in window) {
        const seen = new WeakSet();
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting || seen.has(entry.target)) return;
          seen.add(entry.target);
          observer.unobserve(entry.target);
          if (!motion.matches && typeof entry.target.animate === 'function') {
            entry.target.animate([{opacity: .35, transform: 'translateY(24px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 650, easing: 'cubic-bezier(.22,.7,.2,1)'});
          }
        }), {threshold: .08, rootMargin: '0px 0px -25px 0px'});
        root.querySelectorAll('[data-story-reveal]').forEach(el => observer.observe(el));
        cleanups.push(() => observer.disconnect());
      }
      if (root.matches('[data-et-faq]')) {
        const field = root.querySelector('[data-faq-search]');
        const result = root.querySelector('[data-faq-result]');
        const clear = root.querySelector('[data-faq-clear]');
        const empty = root.querySelector('[data-faq-empty]');
        const categories = Array.from(root.querySelectorAll('[data-faq-category]'));
        const items = Array.from(root.querySelectorAll('[data-faq-question]'));
        let category = 'all';
        const normalize = value => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
        const rows = items.map(element => ({element, category: element.dataset.category || 'essentials', text: normalize(element.textContent)}));
        function filter() {
          const term = normalize(field.value.trim());
          let count = 0;
          rows.forEach(row => {
            const shown = (category === 'all' || row.category === category) && (!term || row.text.includes(term));
            row.element.hidden = !shown;
            if (shown) count++;
          });
          result.textContent = count + ' ' + (count === 1 ? (root.dataset.answerSingular || 'answer') : (root.dataset.answerPlural || 'answers')) + ' ' + (term ? (root.dataset.resultFound || 'found') : (root.dataset.resultExplore || 'to explore'));
          clear.hidden = !term && category === 'all';
          empty.hidden = count !== 0;
          categories.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.faqCategory === category)));
        }
        categories.forEach(button => {
          const count = rows.filter(row => button.dataset.faqCategory === 'all' || row.category === button.dataset.faqCategory).length;
          const badge = button.querySelector('span');
          if (badge) badge.textContent = String(count).padStart(2, '0');
          if (!count) button.hidden = true;
          const handler = () => {category = button.dataset.faqCategory; filter();};
          button.addEventListener('click', handler);
          cleanups.push(() => button.removeEventListener('click', handler));
        });
        if (field && result && clear && empty) {
          const reset = () => {field.value = ''; category = 'all'; filter(); field.focus();};
          field.addEventListener('input', filter);
          clear.addEventListener('click', reset);
          cleanups.push(() => {field.removeEventListener('input', filter); clear.removeEventListener('click', reset);});
          root.querySelectorAll('[data-faq-enhanced]').forEach(el => {el.hidden = false;});
          filter();
        }
      }
      mounted.set(root, () => cleanups.forEach(fn => fn()));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-et-story], [data-et-faq]').forEach(root => {const cleanup = mounted.get(root); if (cleanup) cleanup(); mounted.delete(root);}));
})();
